import { Component, ViewEncapsulation } from "@angular/core";
import { MessageService } from "primeng/api";
import { BannerItem } from "../../interfaces/interfaces";
import { ApiService } from "../../services/api.service";

@Component({
    selector: 'app-bannersort',
    templateUrl: './bannersort.component.html',
    styleUrls: ['bannersort.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BannerSortComponent {

    bannerItems: BannerItem[] = [];

    loadBanners(): void {
        this.apiService.getSimpleTable<BannerItem>('banners', {
            filters: {},
            first: 0,
            rows: -1,
            sortField: 'sortIndex',
            sortOrder: 1
        }).subscribe(({data}) => {
            this.bannerItems = data;
        });
    }

    save(): void {
        this.apiService.sortBanner(this.bannerItems.map((bannerItem: BannerItem) => bannerItem.id)).subscribe(() => {
            this.messageService.add({
              severity: 'success',
              summary: 'Rendezés',
              detail: 'Sikeres rendezés'
            });
        });
    }

    constructor(
        private apiService: ApiService,
        private messageService: MessageService
    ) {
        this.loadBanners();
    }
}